<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'mainMenu.reportsColumnsConfiguration' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'mainMenu.reportsColumnsConfiguration' | translate}}</h1>
  </div>
</div>


 

<crm-manag-reports-col-config *ngIf="addNew" (closeEvent)="closeAdding($event)" [reportName]="selectedName"></crm-manag-reports-col-config>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'app.searchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">
          <p-table #dt [value]="data" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
            <ng-template pTemplate="header">
              <tr>
                <!--<th width="5%">#</th>-->
                <th style="text-align:center">{{'Report Name' | translate}}</th> 
                <th width="10%" style="text-align:center" class="table-edit" *ngIf="canManageReportsColumnsConfigurationPermission">{{'app.edit' | translate}}</th> 
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-format>
              <tr *ngIf="data.length>0 && displayMode==2">
                <td>{{ format  }}</td> 

                <td *ngIf="canManageReportsColumnsConfigurationPermission">
                  <a class="" href="javascript:;" (click)="edit(format)"><i class="fa fa-edit fa-lg font-size-20"></i></a>
                </td>
               
              </tr>
              <tr *ngIf="data.length==0 && displayMode==2">
                <td colspan="5">{{'app.NoDataFound' | translate}}</td>
              </tr>
              <tr *ngIf="displayMode==1">
                <td colspan="5">
                  <div class="row col-sm-12 padding-sm-hr">
                    <div class="container text-center">
                      <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="displayMode==3">
                <td colspan="5">
                  <div class="alert alert-danger alert-dark">
                    <button type="button" class="close" data-dismiss="alert">×</button>
                    {{'app.ServerError' |translate}}.
                  </div>
                </td>

              </tr>
            </ng-template>
          </p-table>
        </div>

      </div>
    </div>
  </div>
</div>
 
